/**
 * H18: the sect neigong ladder. Joining gives tier 1 (the World's join for the six schools, systems/sectJoin.ts for the
 * other two). Tier 2, then tier 3, open in order once the gate in `SECT_UNLOCK` is met: the lower book at its level and
 * the sect rank (badge tier) reached. Opening a book gives it at level 1 and says so (notice).
 * TODO: bamboo-tide and snow-pine have no school and so no badges yet: their gate is the neigong level alone.
 */
import { getNeigong, SECT_NEIGONG, SECT_UNLOCK } from '../data/neigong';
import type { PlayerProgress } from '../progress';
import type { SystemHost, WorldSystem } from './types';
import { playerSect } from './sectJoin';

export { playerSect };

/** The next sect book (tier 2 or 3) the player's progress opens now, or null. Pure. */
export function nextSectBook(pr: PlayerProgress): string | null {
  const sect = playerSect(pr);
  const row = sect ? SECT_NEIGONG[sect] : undefined;
  if (!sect || !row || pr.neigong[row[0]] == null) return null;
  for (const tier of [2, 3] as const) {
    const id = row[tier - 1]!;
    if (pr.neigong[id] != null) continue;
    const gate = SECT_UNLOCK[tier];
    const rankOk = !pr.school || // TODO: rank gate for sects without a school
      (pr.badges[sect] ?? 0) >= gate.badge;
    return rankOk && (pr.neigong[row[tier - 2]!] ?? 0) >= gate.level ? id : null;
  }
  return null;
}

export class SectNeigongSystem implements WorldSystem {
  readonly name = 'sectNeigong';
  constructor(private readonly h: SystemHost) {}

  step(): void {
    const pr = this.h.world.progress;
    for (let i = 0; i < 2; i++) {
      const id = nextSectBook(pr);
      if (!id) return;
      pr.neigong[id] = 1;
      this.h.notice(`ปลดกำลังภายในสำนักขั้น ${getNeigong(id).tier}: ${getNeigong(id).name}`);
      this.h.emit({ type: 'progressChanged' });
    }
  }
}
